import { Select } from '@components/base/inputs';
import { VStack } from '@components/base/layout';
import { useErpSelect } from './useErpSelect';
import { KeyValueEditor } from './KeyValueEditor';
import type { KeyValuePair } from './types';

interface CallErpEndpointConfigPanelProps {
  readonly getValue: (field: string) => unknown;
  readonly setValue: (field: string, value: unknown) => void;
}

export function CallErpEndpointConfigPanel({
  getValue,
  setValue,
}: Readonly<CallErpEndpointConfigPanelProps>) {
  const selectedErpSlug = getValue('config_erp_slug') as string;

  const { registries, endpoints, isLoadingEndpoints } =
    useErpSelect(selectedErpSlug);

  return (
    <VStack gap={4}>
      <Select
        label="ERP Registry"
        required
        options={registries}
        value={selectedErpSlug ?? ''}
        onChange={(value) => {
          setValue('config_erp_slug', value);
          setValue('config_endpoint_slug', '');
        }}
        placeholder="Select an ERP registry"
      />

      <Select
        label="Endpoint"
        required
        options={endpoints}
        value={(getValue('config_endpoint_slug') as string) ?? ''}
        onChange={(value) => setValue('config_endpoint_slug', value)}
        disabled={!selectedErpSlug || isLoadingEndpoints}
        placeholder={isLoadingEndpoints ? 'Loading endpoints…' : 'Select an endpoint'}
      />

      <KeyValueEditor
        keyLabel="Parameter"
        valueLabel="Value"
        valuePlaceholder="e.g. {{claim_id}}"
        helperText="Map parameters to context values. Use {{context_key}} for dynamic values."
        value={(getValue('config_body_mapping') as KeyValuePair[]) ?? []}
        onChange={(value) => setValue('config_body_mapping', value)}
      />
    </VStack>
  );
}
